function pad(value, size = 2) {
  return String(value).padStart(size, '0');
}

export function formatUtc(value, pattern) {
  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const parts = {
    YYYY: date.getUTCFullYear(),
    MM: pad(date.getUTCMonth() + 1),
    DD: pad(date.getUTCDate()),
    HH: pad(date.getUTCHours()),
    mm: pad(date.getUTCMinutes()),
    ss: pad(date.getUTCSeconds()),
    SSS: pad(date.getUTCMilliseconds(), 3),
  };

  return pattern.replace(/YYYY|SSS|MM|DD|HH|mm|ss/g, (token) => parts[token]);
}

export function parseUtcDate(value) {
  if (typeof value !== 'string') {
    return NaN;
  }

  const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) {
    return NaN;
  }

  const year = parseInt(match[1], 10);
  const month = parseInt(match[2], 10);
  const day = parseInt(match[3], 10);

  return Date.UTC(year, month - 1, day);
}



// WEBPACK FOOTER //
// ./src/js/UtcDate.js